// src/views/horarios/HorarioEditView.js
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { updateHorario, deleteHorario } from '../../../controller/HorarioController';
import Horario from '../../../models/Horario'; // Ajusta si la ruta es distinta

function HorarioEditView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [horario, setHorario] = useState(new Horario(location.state?.horario || {}));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHorario({
      ...horario,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedData = { ...horario };

    try {
      await updateHorario(horario.id, updatedData);
      navigate(-1);
    } catch (error) {
      console.error('Error al actualizar el horario:', error);
    }
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este horario? Esta acción no se puede deshacer.');

    if (confirmDelete) {
      try {
        await deleteHorario(horario.id);
        navigate(-1);
      } catch (error) {
        console.error('Error al eliminar el horario:', error);
      }
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Editar Horario</h1></Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="nombre"
            value={horario.nombre}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Hora de Inicio</Form.Label>
          <Form.Control
            type="time"
            name="hora_inicio"
            value={horario.hora_inicio}
            onChange={handleChange}
            step="60"
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Hora de Fin</Form.Label>
          <Form.Control
            type="time"
            name="hora_fin"
            value={horario.hora_fin}
            onChange={handleChange}
            step="60"
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="me-2">
          Guardar Cambios
        </Button>

        <Button variant="secondary" onClick={() => navigate(-1)} className="me-2">
          Volver
        </Button>

        <Button variant="danger" onClick={handleDelete}>
          Eliminar
        </Button>
      </Form>
    </Container>
  );
}

export default HorarioEditView;
